import styled from "styled-components";
import { GenericAssetItem } from "@similarweb/ui-components";

const DEFAULT_ITEM_HEIGHT = "64px";
const INDUSTRY_ICON = "custom-category";

export const FadeWrapper = styled.div<{ opacity?: number }>`
    width: 40px;
    height: 40px;
    display: flex;
    opacity: ${({ opacity = 0 }) => opacity};
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    transition:
        background-color 0.2s ease-out,
        opacity 0.2s linear;

    &:hover {
        background-color: rgba(42, 62, 82, 0.05);
    }
`;

const CustomMarketItemWrapper = styled(GenericAssetItem)<{ height: string }>`
    height: ${({ height }) => height};
    &:hover ${FadeWrapper} {
        opacity: 1;
    }
`;
export const POPUP_CSS_CLASS_CONTAINER = "Popup-element-wrapper--notification-mode";
export const PopupClickContainerStatelessWrapper = styled.div`
    position: relative;
    .${POPUP_CSS_CLASS_CONTAINER} {
        z-index: initial;
    }
`;
